import { isWrappedGetNewsByIdResponse } from 'hb-react/shared/apps/News/types';
import {
  type GetNewsResponse,
  type PublishedNewsData,
} from 'hb-react/shared/apps/News/types';

export const getPublishedNewsData = (
  responseData: GetNewsResponse,
): PublishedNewsData => {
  if (isWrappedGetNewsByIdResponse(responseData)) {
    const { postCommunication } = responseData;

    const news: PublishedNewsData = {
      attachments: postCommunication.attachments,
      categories: postCommunication.categories,
      content: postCommunication.content,
      id: postCommunication.id.toString(),
      likes: postCommunication.likes,
      ogUrl: postCommunication.ogUrl,
      shareUrl: postCommunication.ogUrl, // Use ogUrl as source for backwards compatibility
      publishedAt:
        postCommunication.feedableAt || postCommunication.publishedAt,
      relatedLetters: postCommunication.relatedLetters,
      seoDescription: postCommunication.seoDescription,
      seoTitle: postCommunication.seoTitle,
      socialMediaList: postCommunication.socialMediaList,
      subject: postCommunication.subject,

      // Renamed properties
      seoCanonicalUrl: postCommunication.canonicalUrl || '',
      coverPicture: {
        compressedUrl: postCommunication.newCoverPicture?.compressedUrl || '',
        previewUrl: postCommunication.newCoverPicture?.previewUrl || '',
        mediumUrl: postCommunication.newCoverPicture?.mediumUrl || '',
        wideUrl: postCommunication.newCoverPicture?.wideUrl || '',
      },
      rssUrl: postCommunication.externalUrl || '',
    };

    return news;
  }
  const news: PublishedNewsData = {
    id: responseData.id.toString(),
    publishedAt: responseData.publishedAt,
    seoCanonicalUrl: responseData.seoCanonicalUrl,
    seoDescription: responseData.seoDescription,
    seoTitle: responseData.seoTitle,
    socialMediaList: responseData.socialMediaList,
    content: responseData.content,
    subject: responseData.subject,
    coverPicture: responseData.coverPicture,
    attachments: responseData.attachments,
    ogUrl: responseData.ogUrl,
    shareUrl: responseData.shareUrl,
    categories: responseData.categories,
    likes: responseData.likes,
    rssUrl: responseData.rssUrl || '',

    // Old properties no longer available in the new format
    relatedLetters: [],
  };

  return news;
};
